import { m } from 'framer-motion';

export const Animate = ({ id, children, ...rest }) => (
  <m.div
    key={id}
    animate="center"
    exit="exit"
    initial="enter"
    transition={{ duration: 0.25 }}
    variants={{
      enter: () => ({
        x: 20, //direction > 0 ? 20 : -20,
        opacity: 0,
      }),
      center: {
        zIndex: 1,
        x: 0,
        opacity: 1,
      },
      exit: () => ({
        zIndex: 0,
        x: -20, //direction < 0 ? 20 : -20,
        opacity: 0,
      }),
    }}
    {...rest}
  >
    {children}
  </m.div>
);
